var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHeaderPolygonLightMobile = function SvgHeaderPolygonLightMobile(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 458,
    height: 120,
    viewBox: "0 0 458 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1947_21692",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 458,
    height: 120
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 458,
    height: 120,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1947_21692)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.294 130.293L465.264 83.4858M430.294 130.293L465.264 177.101M430.294 130.293H570.733M465.264 83.4858H535.576M465.264 83.4858L535.576 177.101M535.576 83.4858L570.733 130.293M535.576 83.4858L465.264 177.101M570.733 130.293L535.576 177.101M535.576 177.101H465.264",
    stroke: "#EEEFEF",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.294 37.0929L465.264 -9.30029M430.294 37.0929L465.264 83.4862M430.294 37.0929H570.733M465.264 -9.30029H535.576M465.264 -9.30029L535.576 83.4862M535.576 -9.30029L570.733 37.0929M535.576 -9.30029L465.264 83.4862M570.733 37.0929L535.576 83.4862M535.576 83.4862H465.264",
    stroke: "#EEEFEF",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.694 83.9007L359.663 37.0933M324.694 83.9007L359.663 130.708M324.694 83.9007H465.132M359.663 37.0933H429.976M359.663 37.0933L429.976 130.708M429.976 37.0933L465.132 83.9007M429.976 37.0933L359.663 130.708M465.132 83.9007L429.976 130.708M429.976 130.708H359.663",
    stroke: "#EEEFEF",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.694 -9.30061L359.663 -55.6938M324.694 -9.30061L359.663 37.0926M324.694 -9.30061H465.132M359.663 -55.6938H429.976M359.663 -55.6938L429.976 37.0926M429.976 -55.6938L465.132 -9.30061M429.976 -55.6938L359.663 37.0926M465.132 -9.30061L429.976 37.0926M429.976 37.0926H359.663",
    stroke: "#EEEFEF",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.004 130.293L253.244 83.4858M218.004 130.293L253.244 177.101M218.004 130.293H359.531M253.244 83.4858H324.102M253.244 83.4858L324.102 177.101M324.102 83.4858L359.531 130.293M324.102 83.4858L253.244 177.101M359.531 130.293L324.102 177.101M324.102 177.101H253.244",
    stroke: "#EEEFEF",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.403 83.9007L147.644 37.0933M112.403 83.9007L147.644 130.708M112.403 83.9007H253.93M147.644 37.0933H218.501M147.644 37.0933L218.501 130.708M218.501 37.0933L253.93 83.9007M218.501 37.0933L147.644 130.708M253.93 83.9007L218.501 130.708M218.501 130.708H147.644",
    stroke: "#EEEFEF",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.004 37.0929L253.244 -9.30029M218.004 37.0929L253.244 83.4862M218.004 37.0929H359.531M253.244 -9.30029H324.102M253.244 -9.30029L324.102 83.4862M324.102 -9.30029L359.531 37.0929M324.102 -9.30029L253.244 83.4862M359.531 37.0929L324.102 83.4862M324.102 83.4862H253.244",
    stroke: "#EEEFEF",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80243 130.293L42.0428 83.4858M6.80243 130.293L42.0428 177.101M6.80243 130.293H148.329M42.0428 83.4858H112.901M42.0428 83.4858L112.901 177.101M112.901 83.4858L148.329 130.293M112.901 83.4858L42.0428 177.101M148.329 130.293L112.901 177.101M112.901 177.101H42.0428",
    stroke: "#EEEFEF",
    strokeWidth: 1
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHeaderPolygonLightMobile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "header-polygon-light-mobile.b70365e28342eb220d5650d62d6294cf.svg";